const itemIcon = (itemId: number): string => `https://maplestory.io/api/GMS/214/item/${itemId}/icon`

export const GAME_ICONS = Object.freeze({
  fairyBlessing: '/stream-assets/fairy-blessing.png',
  mapleLeaf: '/stream-assets/maple-leaf.png',
  medal: itemIcon(1142000),
  townScroll: itemIcon(2030000),
  recognition: itemIcon(2460002),
  exp: itemIcon(2022450),
  mesos: itemIcon(4031138),
  hp: itemIcon(2000000),
  mp: itemIcon(2000003),
})
